export default __webpack_public_path__ + "static/media/times-bold.1bc432f7.ttf";